import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InquiryGateway() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="inquiry-gateway" className="dark bg-background text-foreground relative min-h-[70vh] flex items-center justify-center overflow-hidden border-b border-border/20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/80 z-10" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/minimal_skyline_dark.png" alt="Urban skyline silhouette" className="w-full h-full object-cover opacity-40 grayscale" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-6 md:px-12 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-border to-transparent mb-8" />

        {}
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight mb-6 text-transparent bg-clip-text bg-gradient-to-b from-white via-gray-200 to-gray-500 drop-shadow-sm">
          The Gateway to Capital
        </h1>

        {}
        <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl tracking-wide font-light mb-10">
          Institutional inquiries and funding requests.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-6 items-center">
          <Button asChild variant="outline" className="h-12 px-8 border-border/40 hover:bg-white/5 hover:text-white hover:border-white/60 transition-all duration-300 text-base font-medium tracking-wide rounded-sm uppercase">
            <Link to="#contact-form">
              Initiate Request
            </Link>
          </Button>
        </div>

        {}
        <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 animate-pulse opacity-50">
          <ChevronDown className="w-6 h-6 text-muted-foreground" />
        </div>
      </div>
    </section>;
}